export default __webpack_public_path__ + "static/media/nbs-book-empty-cover.e76bf0f7.jpg";